import type { Routes } from '@angular/router';

export const AGGREGATED_REVIEWS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/reviews/layouts/aggregated-reviews-layout/aggregated-reviews-layout.component').then(
                (m) => m.AggregatedReviewsLayoutComponent
            ),
    },
];
